import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ProviderCard from '../components/ProviderCard';
import { getCategoryBySlug } from '../data/categories';
import { fetchProviders } from '../api/client';

export default function CategoriaDetalle() {
  const { slug } = useParams();
  const category = getCategoryBySlug(slug);
  const [sort, setSort] = useState('rating');
  const [city, setCity] = useState('');
  const [providers, setProviders] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setStatus('loading');
    fetchProviders({ category: slug, limit: 50 })
      .then((data) => {
        if (!active) return;
        setProviders(data.providers);
        setStatus('ready');
      })
      .catch(() => active && setStatus('error'));
    return () => {
      active = false;
    };
  }, [slug]);

  const cities = useMemo(() => Array.from(new Set(providers.map((p) => p.city))).sort(), [providers]);

  const filtered = useMemo(() => {
    let list = city ? providers.filter((p) => p.city === city) : providers;
    list = [...list].sort((a, b) => {
      if (sort === 'rating') return b.rating - a.rating;
      if (sort === 'price-asc') return a.priceFrom - b.priceFrom;
      if (sort === 'price-desc') return b.priceFrom - a.priceFrom;
      return 0;
    });
    return list;
  }, [providers, city, sort]);

  if (!category) {
    return (
      <section className="section page-section">
        <h1>Categoría no encontrada</h1>
        <Link to="/categorias" className="btn btn-outline">Volver a categorías</Link>
      </section>
    );
  }

  return (
    <section className="section page-section">
      <div className="section-header">
        <span className="category-icon-big">{category.icon}</span>
        <h1>{category.name}</h1>
        <p>{category.description}</p>
      </div>

      <div className="filters-bar">
        <select value={city} onChange={(e) => setCity(e.target.value)}>
          <option value="">Todas las ciudades</option>
          {cities.map((c) => <option value={c} key={c}>{c}</option>)}
        </select>
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="rating">Mejor calificados</option>
          <option value="price-asc">Precio: menor a mayor</option>
          <option value="price-desc">Precio: mayor a menor</option>
        </select>
        <span className="results-count">{filtered.length} proveedores encontrados</span>
      </div>

      {status === 'error' && (
        <p className="empty-state">No pudimos cargar los proveedores. Verifica tu conexión e intenta de nuevo.</p>
      )}
      {status === 'ready' && filtered.length > 0 && (
        <div className="provider-grid">
          {filtered.map((p) => <ProviderCard provider={p} key={p.id} />)}
        </div>
      )}
      {status === 'ready' && filtered.length === 0 && (
        <p className="empty-state">Aún no hay proveedores registrados en esta categoría y ciudad.</p>
      )}
    </section>
  );
}
